<template>
  <div class="discountForm">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :disabled="fundPaymentBillFlag == '1' ? true : !isEdit || !canEdit"
      @input="handleChangeBaseData"
      @change="handleBlurChange"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';

  export default {
    name: 'discountForm',
    components: {
      baseForm,
    },
    props: ['isEdit', 'departmentList', 'canEdit', 'basicInfo', 'fundPaymentBillFlag'],
    data() {
      return {
        baseData: {
          id: null,
          discountDate: null,
          discountRate: null,
          discountDays: null,
          billBookValue: null,
          billMaturityValue: null,
          discountCharge: null,
          discountIncomeAmount: null,
          discountReceiptDate: null,
          serviceCharge: null,
          serviceChargeType: null,
          serviceChargeSerialNumber: null,
          discountDepartmentCode: null,
          discountDepartmentName: null,
          discountBankNo: null,
          discountBankName: null,
          discountBankAccount: null,
          ourDiscountInterest: null,
          upstreamDiscountInterest: null,
          downstreamDiscountInterest: null,
        },
      };
    },
    computed: {
      baseDataOptions() {
        //基础数据表单配置
        return [
          {
            // 贴现日期
            type: 'date',
            label: this.$t('billDetail.discountForm.discountDate'),
            prop: 'discountDate',
          },
          {
            // 贴现利率
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.discountRate'),
            prop: 'discountRate',
            precision: this.$globalVar.iPoint,
          },
          {
            // 贴现天数
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.discountDays'),
            prop: 'discountDays',
            precision: this.$globalVar.dPoint,
            maxlength: '20',
            max: 99999999999999999999,
            min: 0,
          },
          {
            // 票据账面价值
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.billBookValue'),
            prop: 'billBookValue',
            max: 99999999999.99,
            min: 0,
          },
          {
            // 票据到期价值
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.billMaturityValue'),
            prop: 'billMaturityValue',
            max: 99999999999.99,
            min: 0,
          },
          {
            // 预计贴现息
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.preDiscountCharge'),
            prop: 'preDiscountCharge',
            max: 99999999999.99,
            min: 0,
            disabled: true,
          },
          {
            // 贴现息
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.discountCharge'),
            prop: 'discountCharge',
            max: 99999999999.99,
            min: 0,
          },
          {
            // 贴现所得金额
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.discountIncomeAmount'),
            prop: 'discountIncomeAmount',
            max: 99999999999.99,
            min: 0,
          },
          {
            // 贴现收款日期
            type: 'date',
            label: this.$t('billDetail.discountForm.discountReceiptDate'),
            prop: 'discountReceiptDate',
          },
          // {
          //   // 贴现承担方
          //   type: 'select',
          //   label: this.$t('billDetail.discountForm.bearerType'),
          //   prop: 'bearerType',
          //   options: this.$baseRequest.getDictListMapByType('bill_bearer_type'),
          //   required: this.basicInfo.bearerType,
          //   filterable: true,
          // },
          {
            // 手续费
            type: 'amountNumber',
            label: this.$t('billDetail.discountForm.serviceCharge'),
            prop: 'serviceCharge',
            max: 99999999999.99,
            min: 0,
          },
          /* {
            // 手续费科目改为贴现息科目
            type: 'searchTable',
            prop: 'serviceChargeType',
            searchType: 'account',
            isMultiple: true,
            required: this.basicInfo.discountType,
            label: this.$t('billDetail.discountForm.serviceChargeType'),
            currentValue: this.baseData.serviceChargeType,
          },
          {
            // 手续费现金流量代码改为贴现息现金流量代码
            type: 'searchTable',
            label: this.$t('billDetail.discountForm.serviceChargeSerialNumber'),
            prop: 'serviceChargeSerialNumber',
            searchType: 'cashflow',
            isMultiple: true,
            required: this.basicInfo.discountType,
            currentValue: this.baseData.serviceChargeSerialNumber,
          }, */
          {
            // 贴现部门
            type: 'select',
            label: this.$t('billDetail.discountForm.discountDepartmentCode'),
            prop: 'discountDepartmentCode',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 贴现银行
            type: 'searchTable',
            prop: 'discountBankName',
            searchType: 'bankAccountBranchName',
            isMultiple: true,
            label: this.$t('billDetail.discountForm.discountBankNo'),
            name: 'discountBankName',
            getName: 'discountBankName',
            currentValue: this.baseData.discountBankName,
          },
          {
            // 贴现银行账号
            type: 'input',
            label: this.$t('billDetail.discountForm.discountBankAccount'),
            prop: 'discountBankAccount',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
          },
          {
            // 上游贴息
            type: 'input',
            label: '上游贴息',
            prop: 'upstreamDiscountInterest',
            placeholder: '请输入',
          },
          {
            // 下游贴息
            type: 'input',
            label: '下游贴息',
            prop: 'downstreamDiscountInterest',
            placeholder: '请输入',
          },
          {
            // 我方贴息
            type: 'input',
            label: '我方贴息',
            prop: 'ourDiscountInterest',
            placeholder: '请输入',
          },
        ];
      },
    },
    watch: {
      'basicInfo.billAmount': function () {
        this.getAmount('discountCharge');
        this.getAmount('billAmount');
      },
      'basicInfo.expiringDate': function () {
        this.getAmount('expiringDate');
      },
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'serviceChargeType') {
          // 手续费科目
          this.searchTableChange(value.serviceChargeType, [
            { val: 'serviceChargeType', getVal: 'accountCode' },
          ]);
        } else if (prop == 'serviceChargeSerialNumber') {
          // 手续费现金流量代码
          this.searchTableChange(value.serviceChargeSerialNumber, [
            { val: 'serviceChargeSerialNumber', getVal: 'cashflowCode' },
          ]);
        } else if (prop == 'discountDepartmentCode') {
          // 贴现部门
          this.baseData.discountDepartmentName = this.getName(
            value.discountDepartmentCode,
            'departmentList'
          );
        } else if (prop == 'discountBankName') {
          // 贴现银行
          this.searchTableChange(value.discountBankName, [
            { val: 'discountBankName', getVal: 'branchName' },
            { val: 'discountBankNo', getVal: 'branchCode' },
            { val: 'discountBankAccount', getVal: 'bankAccountNum' },
          ]);
        } else if (prop == 'discountRate' || prop == 'discountDate') {
          this.getAmount(prop);
        } else if (prop == 'discountCharge') {
          this.getAmount('discountCharge');
        }
      },
      handleBlurChange(value, prop) {
        if (prop == 'discountIncomeAmount') {
          if (
            this.baseData.discountIncomeAmount !=
            this.$cal.calCommon(
              this.basicInfo.billAmount,
              this.baseData.discountCharge,
              '-',
              'amount'
            )
          ) {
            this.tips('discountIncomeAmountTip', 'error');
            this.baseData.discountIncomeAmount = null;
            return;
          }
        }
      },
      getAmount(type) {
        if (type == 'discountCharge') {
          if (this.baseData.discountCharge) {
            this.baseData.discountIncomeAmount = this.$cal.calCommon(
              this.basicInfo.billAmount,
              this.baseData.discountCharge,
              '-',
              'amount'
            );
          } else {
            this.baseData.discountIncomeAmount = null;
          }
        } else if (type == 'discountRate' || type == 'discountDate') {
          if (!this.basicInfo.expiringDate) {
            this.baseData.preDiscountCharge = null;
            return;
          }
          if (!this.baseData.discountDate) {
            this.baseData.preDiscountCharge = null;
            return;
          }
          let days = this.calc_day(
            new Date(this.basicInfo.expiringDate).getTime(),
            new Date(this.baseData.discountDate).getTime()
          );
          this.baseData.preDiscountCharge = this.$cal.calCommon(
            days,
            (this.baseData.discountRate / 360) * this.basicInfo.billAmount,
            '*',
            'amount'
          );
        } else if (type == 'expiringDate' || type == 'billAmount') {
          if (this.baseData.discountDate) {
            let days = this.calc_day(
              new Date(this.basicInfo.expiringDate).getTime(),
              new Date(this.baseData.discountDate).getTime()
            );
            this.baseData.preDiscountCharge = this.$cal.calCommon(
              days,
              (this.baseData.discountRate / 360) * this.basicInfo.billAmount,
              '*',
              'amount'
            );
          }
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`billDetail.message.${info}`),
          type: type,
        });
      },
      calc_day(timestamp1, timestamp2) {
        // 将时间戳相减获得差值（毫秒数）
        var differ = timestamp1 - timestamp2;
        /**
         * @desc 毫秒数除以1000就转为秒数
         * @desc 秒数除以60后取整，就是分钟（因为1分钟等于60秒）
         * @desc 秒数除以3600后取整，就是小时（因为1小时等于3600秒）
         * @desc 小时数除以24后取整，就是相差的天数
         */
        var day = differ / 1000 / 60 / 60 / 24;
        return parseInt(day);
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.baseData[item.val] = val[0][item.getVal];
            } else {
              this.baseData[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.baseData[item.val] = null;
          });
        }
      },
      getName(val, listName) {
        // 名称赋值
        return val ? this[listName].find((item) => item.value == val).label : null;
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            /* let { discountCharge, discountIncomeAmount, billBookValue } = this.baseData;
            if (!billBookValue) {
              billBookValue = 0;
            }
            if (this.$cal.calCommon(discountCharge, discountIncomeAmount, '+') != billBookValue) {
              this.$message({
                showClose: true,
                message: this.$t('billDetail.message.discountVerifyAmount'),
                type: 'error',
              });
              sign = false;
            } else {
              sign = true;
            } */
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
    },
  };
</script>
